const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ components
const EmitedTransfersFilters = require('./emitedTransfersFilters/emitedTransfersFilters');
const { EmitedTransfersContent } = require('./emitedTransfersContent/emitedTransfersContent');

class EmitedTransfers extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filtersSectionOpen: false
        }

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.handleSetFilters = this.handleSetFilters.bind(this);
        this.handleResetFilter = this.handleResetFilter.bind(this);
        this.handleClearFilters = this.handleClearFilters.bind(this);
        this.handleTransfersFetch = this.handleTransfersFetch.bind(this);
    }

    componentDidMount() {
        const { requestEmitedTransfers, immAccount } = this.props;
        const accountId = immAccount.get('accountId');
        requestEmitedTransfers(accountId);
    }

    componentDidUpdate(prevProps) {
        const accountId = this.props.immAccount.get('accountId');
        const prevAccountId = prevProps.immAccount.get('accountId');

        if (accountId !== prevAccountId) {
            const { requestEmitedTransfers } = this.props;
            requestEmitedTransfers(accountId);
        }
    }

    handleClearFilters() {
        this.props.clearFilters();
        this.handleTransfersFetch();
    }

    handleResetFilter(filters) {
        //In same cases, we need to reset more than one filter at once
        filters.forEach(filter => {
            this.props.resetFilter(filter);
        });
        this.handleTransfersFetch();
    }

    handleSetFilters(filters) {
        this.props.setFilters(filters);
        this.handleTransfersFetch();
    }

    handleToggleFilters() {
        this.setState({
            filtersSectionOpen: !this.state.filtersSectionOpen
        });
    }

    handleTransfersFetch(){
        const { immAccount, requestEmitedTransfers } = this.props;
        const accountId = immAccount.get('accountId');
        requestEmitedTransfers(accountId);
    }

    render() {
        const {
            immEmitedTransfers,
            immAccount,
            immScreen,
            isInactiveAccountsEnabled,
            requestEmitedTransfersNextPage,
        } = this.props;

        const immFilter = immEmitedTransfers.get('filters');
        const accountCurrency = immAccount.get('balance').get('currency');

        return (
            <div>
                <EmitedTransfersFilters
                    accountCurrency={accountCurrency}
                    immFilter={immFilter}
                    isOpen={this.state.filtersSectionOpen}
                    onCloseClick={this.handleToggleFilters}
                    onSetFilters={this.handleSetFilters}
                />
                <EmitedTransfersContent
                    immEmitedTransfers={immEmitedTransfers}
                    immAccounts={this.props.immAccounts}
                    immAccount={immAccount}
                    immFilter={immFilter}
                    immScreen={immScreen}
                    isInactiveAccountsEnabled={isInactiveAccountsEnabled}
                    onFilterClick={this.handleToggleFilters}
                    onTransfersFetch={this.handleTransfersFetch}
                    onResetFilter={this.handleResetFilter}
                    onClearFilters={this.handleClearFilters}
                    requestEmitedTransfersNextPage={requestEmitedTransfersNextPage}
                />
            </div>
        );
    }
}

EmitedTransfers.propTypes = {
    immEmitedTransfers: PropTypes.object.isRequired,
    immAccount: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    requestEmitedTransfers: PropTypes.func.isRequired,
    setFilters: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
    requestEmitedTransfersNextPage: PropTypes.func.isRequired
};

module.exports = EmitedTransfers;
